import type { CompanyChannelPermissionConfig } from "./types";

/**
 * Builds a CompanyChannelPermissionConfig for permissions that are only app-group scoped
 * (not team-scoped). Use this for permissions like "viewCatalogs", "importUsers", or
 * "externalIntegrations" that don't have team-level granularity.
 *
 * @param permission - The permission name (e.g., "viewCatalogs")
 * @param hasPermission - Whether the user has this permission at the app group level
 * @returns A stable config object suitable for Pusher subscription
 */
export const buildAppGroupOnlyPermissionConfig = (
  permission: string,
  hasPermission: boolean
): CompanyChannelPermissionConfig => ({
  permission,
  hasAppGroupPermission: hasPermission,
  teamIdsWithPermission: [],
});
